import script from "./ShowError.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowError.vue?vue&type=script&setup=true&lang=js"

import "./ShowError.vue?vue&type=style&index=0&id=1052d428&lang=scss&scoped=true"

import exportComponent from "/Users/rantalmor/Desktop/volta-vue/proposal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1052d428"]])

export default __exports__